// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // header
  aboutMe: 'About me',
  projects: 'Projects',
  education: 'Education',
  contact: 'Contact',

  // Bio
  hi: 'Hello',
  myName: 'My name is',
  buildForWeb: 'I build things for web.',

  // tech stack
  my: 'My',
  techWorking: "Technologies I've been working with recently",

  // projects
  ThingsIveBuilt: "Projects I have participated in so far.",
  livePreview: 'Live Preview',
  viewCode: 'View Code',

  // contacts

  // about me

  // fatec
  FATECprojects: 'Integrative Projects - APIs',
  FatecThingsIveBuilt: "API projects in which I participated at FATEC São José dos Campos.",
}